const auth = {
    login: 'ログイン',
    logout: 'ログアウト',
    email: 'メールアドレス',
    password: 'パスワード',
    rememberMe: 'ログイン状態を保持',
    forgotPassword: 'パスワードをお忘れですか？',
    resetPassword: 'パスワードをリセット',
    tenantCode: 'テナントコード',
    loginError: 'ログインに失敗しました',
    invalidCredentials: 'メールアドレスまたはパスワードが正しくありません',
    // Server error codes — loginError is the unknown-code fallback
    errorCodes: {
      AUTH_INVALID_CREDENTIALS: 'メールアドレスまたはパスワードが正しくありません',
      AUTH_MFA_REQUIRED: '確認コードを入力してください',
      AUTH_INVALID_MFA: '確認コードが正しくありません。もう一度お試しください。',
      AUTH_TENANT_CODE_REQUIRED: 'テナントコードを入力してください',
      AUTH_DOCUMENT_TENANT_MISMATCH: '選択したユーザーはこのドキュメントと異なるテナントに所属しています',
    },
    // Login Page
    signInPrompt: 'アカウントにサインイン',
    signIn: 'サインイン',
    emailAddress: 'メールアドレス',
    tenantCodePlaceholder: '例: ACME',
    emailPlaceholder: 'user@example.com',
    togglePasswordVisibility: 'パスワード表示を切り替え',
    // Forgot Password Page
    forgotPasswordTitle: 'パスワードをお忘れですか？',
    forgotPasswordDescription: 'メールアドレスとテナントコードを入力してください。パスワードリセット用のリンクをお送りします。',
    sendResetLink: 'リセットリンクを送信',
    backToLogin: 'ログインに戻る',
    checkYourEmail: 'メールを確認してください',
    resetLinkSent: 'パスワードリセット用のリンクを送信しました：',
    checkSpamFolder: 'メールが届かない場合は、迷惑メールフォルダをご確認ください。',
    // Reset Password Page
    resetPasswordTitle: 'パスワードをリセット',
    resetPasswordDescription: '新しいパスワードを入力してください。',
    newPassword: '新しいパスワード',
    confirmNewPassword: '新しいパスワード（確認）',
    passwordResetSuccess: 'パスワードのリセットが完了しました',
    passwordResetSuccessMessage: 'パスワードが正常にリセットされました。新しいパスワードでサインインできます。',
    goToLogin: 'ログインへ',
    passwordsDoNotMatch: 'パスワードが一致しません',
    passwordRequirementsNotMet: 'パスワードが最低セキュリティ要件を満たしていません。',
    invalidResetToken: '無効または期限切れのリセットトークンです。新しいパスワードリセットをリクエストしてください。',
    resetLinkExpired: 'パスワードのリセットに失敗しました。リセットリンクが期限切れの可能性があります。',
    // Password requirements
    passwordRequirements: 'パスワード要件：',
    minLength: '8文字以上',
    hasUpperCase: '大文字を1つ以上',
    hasLowerCase: '小文字を1つ以上',
    hasNumber: '数字を1つ以上',
    hasSpecial: '特殊文字を1つ以上',
    // Form validation
    emailRequired: 'メールアドレスを入力してください',
    emailInvalid: '有効なメールアドレスを入力してください',
    passwordRequired: 'パスワードを入力してください',
    tenantCodeRequired: 'テナントコードを入力してください',
    sendResetLinkError: 'リセットリンクの送信に失敗しました。もう一度お試しください。',
    // Login heading (Type A)
    signInTitle: 'おかえりなさい',
    signInSubtitle: 'ナレッジワークスペースにサインインしてください',
    // The brand panel carries no copy — see BrandPanel.tsx. Its former headline,
    // subtitle, feature bullets and copyright keys were removed with it rather
    // than left orphaned; the approved left-half visual will bring its own.
  };

export default auth;
